// extracted by mini-css-extract-plugin
module.exports = {"sliders":"QuickControls_sliders__2YlIn"};